import { TabItem } from 'src/views/components/components.interfaces';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';
import StudentProfileTab from './components/StudentProfileTab.component';
import StudentAttendanceTab from './components/StudentAttendanceTab.component';
import StudentFeesTab from './components/StudentFeesTab.component';
import StudentAssessmentsTab from './components/StudentAssessmentsTab.component';
import StudentDocumentsTab from './components/StudentDocumentsTab.component';

export const studentDetailsSubRouteIds = [
  'profile',
  'attendance',
  'fees',
  'assessments',
  'documents',
];

export const getStudentDetailsTabMenuItems = (
  translateText: TTranslateTextType,
  studentId: string
): TabItem[] => {
  return [
    {
      label: translateText('students.studentDetails.tabs.profile'),
      onClickHandler: () => {
        // Handled by route navigation
      },
      tabPanel: <StudentProfileTab studentId={studentId} />,
    },
    {
      label: translateText('students.studentDetails.tabs.attendance'),
      onClickHandler: () => {
        // Handled by route navigation
      },
      tabPanel: <StudentAttendanceTab studentId={studentId} />,
    },
    {
      label: translateText('students.studentDetails.tabs.fees'),
      onClickHandler: () => {
        // Handled by route navigation
      },
      tabPanel: <StudentFeesTab studentId={studentId} />,
    },
    {
      label: translateText('students.studentDetails.tabs.assessments'),
      onClickHandler: () => {
        // Handled by route navigation
      },
      tabPanel: <StudentAssessmentsTab studentId={studentId} />,
    },
    {
      label: translateText('students.studentDetails.tabs.documents'),
      onClickHandler: () => {
        // Handled by route navigation
      },
      tabPanel: <StudentDocumentsTab studentId={studentId} />,
    },
  ];
};

export const getStudentDetailsTabIndex = (pathname: string): number => {
  const studentDetailsTabsIndexObject: Record<string, number> = {
    profile: 0,
    attendance: 1,
    fees: 2,
    assessments: 3,
    documents: 4,
  };

  return studentDetailsTabsIndexObject[pathname] ?? 0;
};

export const getStudentDetailsSubRouteId = (index: number): string =>
  studentDetailsSubRouteIds[index] || studentDetailsSubRouteIds[0];
